'use client';

import { useMetrica } from 'next-yandex-metrica';
import { useCallback, useEffect, useRef } from 'react';

import { createViewTracker } from '@/features/candidate-interview';
import { promoEvent } from '@/features/interview-promo/model';
import type { CandidateInterviewAttemptV1 } from '@/shared/api';
import { Button } from '@/shared/ui/button';

export function CandidateCourseReward({
	interviewId,
	reward,
	source = 'direct',
}: {
	interviewId: string;
	reward: NonNullable<CandidateInterviewAttemptV1['courseReward']>;
	source?: string;
}) {
	const { reachGoal } = useMetrica();
	const seen = useRef(createViewTracker());
	const { courseId, granted } = reward;
	const track = useCallback(
		(event: string) =>
			promoEvent(reachGoal, event, {
				courseId,
				interviewId,
				source: source === 'landing' ? 'landing' : 'direct',
				outcome: granted ? 'granted' : 'unavailable',
			}),
		[reachGoal, courseId, interviewId, source, granted],
	);
	useEffect(() => {
		if (seen.current(`view:${courseId}`)) track('course_reward_view');
		if (seen.current(`result:${courseId}:${granted}`))
			track('course_reward_result');
	}, [courseId, granted, track]);

	return (
		<section
			aria-label="Продолжить обучение"
			className="mt-4 rounded-xl bg-gray-5/70 p-5 ring-1 ring-inset ring-gray-4/40"
		>
			<h2 className="text-lg font-semibold">
				Переходи к бесплатному курсу, чтобы подготовиться к собесу
			</h2>
			<Button
				variant="primary"
				size="44"
				href={granted ? `/course/${encodeURIComponent(courseId)}` : undefined}
				disabled={!granted}
				onClick={granted ? () => track('course_reward_open') : undefined}
				className="mt-4"
			>
				Перейти к курсу
			</Button>
		</section>
	);
}
